<template>
  <generic-modal
    :height="duplicateAddressPopup.height"
    :width="duplicateAddressPopup.width"
    :modalClass="'full-screen-popup lg-screen-centered my-address-modal-container'"
    :contentScroll="false"
    :background="'transparent'"
    :backgroundBody="'white'"
    :animationStyle="'slide-up-stick-bottom'"
    @close="closeDuplicateAddressPopup($event, '')"
  >
    <template v-slot:header>
      <div>
        <img
          :src="staticImgBaseUrl + '/images/global/handle-bg.svg'"
          class="handle-bg"
        /></div
    ></template>
    <template v-slot:body>
      <div>
        <div class="flex-column ptb16 tc">
          <VueLottiePlayer
            name="confettiAnim"
            width="60px"
            height="60px"
            :loop="false"
            :animationData="require(`../../assets/Csat/checkLottie.json`)"
            class="check-lottie"
            v-if="clientPlatform !== 'Web'"
          />
          <div class="fs-18 fw-700 pb5 plr16">{{ heading }}</div>
          <div
            class="fs-14 color-slaty plr16"
            v-if="ticketMessage"
            v-html="ticketMessage"
          ></div>
          <div
            class="question-block mlr16 mt12 p12 tl"
            v-if="additionalFeedbackForm"
          >
            <div class="fs-14 fw-800">
              {{ additionalFeedbackForm.title }}
            </div>
            <div class="fs-12 color-slaty">
              {{ additionalFeedbackForm.subTitle }}
            </div>
            <div class="option-area mt12 pt12">
              <div
                class="option-item mb10"
                v-for="(tag, index) in additionalFeedbackForm.tags"
                :key="index"
              >
                <label class="d-flex gap10">
                  <div class="radio-wrapper" v-if="true">
                    <label class="radio">
                      <input
                        type="radio"
                        :name="'additionalInfo'"
                        :value="tag"
                        @change="setRadioButton"
                      />
                      <i><span></span></i>
                    </label>
                  </div>
                  <span>{{ tag }}</span>
                </label>
              </div>
            </div>
          </div>
          <div
            class="plr16 color-slaty"
            v-if="true && !radioBtnVal && additionalFeedbackForm"
          >
            You will be redirected to Home Screen in
            <div class="fw-800">{{ defaultRedirectionTime / 1000 }} sec</div>
          </div>
          <div class="plr16" v-else>
            <button
              class="btn bold secondary mt20 fw-700 width100"
              @click="goToParentPage()"
              v-if="!additionalFeedbackForm && ticketMessage"
            >
              {{ "Okay" }}
            </button>
            <button
              class="btn bold secondary mt12 fw-700 width100"
              @click="submitForm()"
              v-if="radioBtnVal"
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    </template>
    <template v-slot:footer> </template>
  </generic-modal>
</template>
<script>
import GenericModal from "../GenericModal.vue";
import { keyMapsAction } from "../../helpers/storeKeys";
import { staticImgBaseUrl } from "../../config/apiEndpoints";
import { defineAsyncComponent } from "vue";
import PageNames from "../../config/pageNames";
import LocalStorageFunc from "../../helpers/localStorageFunc";
import Utility from "../../helpers/utility";
export default {
  name: "CsatThankYou",
  components: {
    GenericModal,
    VueLottiePlayer: defineAsyncComponent(() => import("vue-lottie-player")),
  },
  props: {
    thanksProps: { required: true },
  },
  data() {
    return {
      duplicateAddressPopup: {
        height: "100vh",
        width: "100%",
      },
      staticImgBaseUrl,
      ratingData: ["food", "delivery", "money_value"],
      inputValue: "",
      checked: false,
      commentError: "",
      radioBtnVal: "",
      defaultRedirectionTime: 5000,
      startTimer: true,
      intervalId: null,
    };
  },
  mounted() {
    this.defaultRedirectionTime = this.thanksProps?.timerInMillis
      ? this.thanksProps?.timerInMillis
      : this.defaultRedirectionTime;
    this.startCountDown();
  },
  methods: {
    submitForm() {
      this.$store.dispatch(keyMapsAction.SUBMIT_CSAT_ADDITIONAL_FEEDBACK_API, {
        tags: this.additionalFeedbackForm.tags,
        tag: this.radioBtnVal,
        id: this.csatId,
      });
    },

    setRadioButton(e) {
      this.startTimer = false;
      if (e.target.checked) {
        this.radioBtnVal = e.target.value;
      }
    },

    startCountDown() {
      if (!this.startTimer) {
        this.intervalId = null;
        return; // Stop if flag is false
      }
      if (this.defaultRedirectionTime > 0) {
        this.defaultRedirectionTime -= 1000;
        this.intervalId = setTimeout(this.startCountDown, 1000);
      } else {
        this.goToPreviousPage();
        this.startTimer = false;
        this.intervalId = null;
      }
    },
    goToPreviousPage() {
      if (
        LocalStorageFunc.getSessionStorageKey("screenName") ===
        PageNames.ORDERHISTORY_PAGE
      ) {
        Utility.sendToOrderHistory();
      } else {
        Utility.sendToHomepageScreen();
      }
    },
  },
  computed: {
    heading() {
      return "Thank you for sharing your feedback";
    },
    ticketMessage() {
      return this.thanksProps?.supportTicketId
        ? this.thanksProps?.ticketMessage?.replace(/#(.*?)\./, (match, p1) => {
            return `<strong class='fw-700'>XXXX${this.thanksProps?.supportTicketId}</strong>.`;
          })
        : "";
    },
    additionalFeedbackForm() {
      return this.thanksProps?.additionalFeedback;
    },
    csatId() {
      return this.thanksProps?.id;
    },
  },
};
</script>
